import React, { useEffect, useRef, useState } from "react";
import NoDataFound from "../../../../Extra/NoDataFound";
import DownloadExcel from "../../../../Extra/DownloadExcel";

const tableHead = [
  "Sno",
  "Month",
  "Crew Demanded",
  "Crew Given",
  "Crew Utilized",
  "Crew Wasted",
  "Loco Demanded",
  "Loco Given",
  "Loco Wasted",
];

const keyToSum = [
  "CR_DEMANDED",
  "CR_GIVEN",
  "CR_UTILIZED",
  "CR_WASTED",
  "LOCO_DEMANDED",
  "LOCO_GIVEN",
  "LOCO_WASTED",
];

const MonthWisePosition = ({ data }) => {
  const [sum, setSum] = useState({});
  const [totalSum, setTotalSum] = useState({});
  const tableRef = useRef(null);

  function sumByMonth(arr, keys) {
    return arr.reduce((result, obj) => {
      const monthKey = new Date(obj.CR_DATE).toISOString().slice(0, 7); // e.g. "2025-07"

      if (!result[monthKey]) {
        result[monthKey] = {};
        keys.forEach((k) => (result[monthKey][k] = 0));
      }

      keys.forEach((k) => {
        result[monthKey][k] += Number(obj[k]) || 0;
      });

      return result;
    }, {});
  }

  function calculateTotal(sumObj, keys) {
    const total = {};
    keys.forEach((k) => {
      total[k] = Object.values(sumObj).reduce(
        (acc, monthData) => acc + (monthData[k] || 0),
        0
      );
    });
    return total;
  }

  useEffect(() => {
    if (data?.length > 0) {
      const s = sumByMonth(data, keyToSum);
      setSum(s);
      setTotalSum(calculateTotal(s, keyToSum));
    }
  }, [data]);

  return (
    <div>
      <div
        //   style={{ maxHeight: "600px", overflow: "auto" }}
        className="border border-dark mb-1 papaDiv"
      >
        <h5
          className="pb-1  "
          style={{ background: "rgba(160, 160, 160, 0.77)" }}
        >
          Month wise
        </h5>
        <div className="table-responsive">
          <table
            className="table table-hover table-striped m-0 p-0"
            ref={tableRef}
          >
            <thead className="sticky-top">
              <tr className="table-dark">
                {tableHead.map((head, i) => (
                  <th key={i}>{head}</th>
                ))}
              </tr>
            </thead>

            {data?.length > 0 && (
              <React.Fragment>
                <tbody>
                  {Object.entries(sum).map(([month, Obj], index) => (
                    <tr key={month}>
                      <td>{index + 1}</td>
                      <td>{month}</td>
                      <td>{Obj.CR_DEMANDED}</td>
                      <td>{Obj.CR_GIVEN}</td>
                      <td>{Obj.CR_UTILIZED}</td>
                      <td>{Obj.CR_WASTED}</td>
                      <td>{Obj.LOCO_DEMANDED}</td>
                      <td>{Obj.LOCO_GIVEN}</td>
                      <td>{Obj.LOCO_WASTED}</td>
                    </tr>
                  ))}
                </tbody>

                <tfoot className="table-dark sticky-bottom">
                  <tr>
                    <td colSpan={2}>Total</td>
                    <td>{totalSum.CR_DEMANDED}</td>
                    <td>{totalSum.CR_GIVEN}</td>
                    <td>{totalSum.CR_UTILIZED}</td>
                    <td>{totalSum.CR_WASTED}</td>
                    <td>{totalSum.LOCO_DEMANDED}</td>
                    <td>{totalSum.LOCO_GIVEN}</td>
                    <td>{totalSum.LOCO_WASTED}</td>
                  </tr>
                </tfoot>
              </React.Fragment>
            )}
          </table>

          {data?.length === 0 && <NoDataFound />}
        </div>
      </div>
      <DownloadExcel
        tableRef={tableRef}
        fileName={`Crew Month wise Position `}
      />
    </div>
  );
};

export default MonthWisePosition;
